<?xml version="1.0" encoding="UTF-8"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<!-- Creator: CorelDRAW 2020 (64-Bit) -->
<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
viewBox="0 0 3598.32 3598.32"
 xmlns:xlink="http://www.w3.org/1999/xlink"
 xmlns:xodm="http://www.corel.com/coreldraw/odm/2003">
 <defs>
  <style type="text/css">
   <![CDATA[
    .fil0 {fill:black;fill-rule:nonzero}
   ]]>
  </style>
 </defs>
 <g id="Layer_x0020_1">
  <metadata id="CorelCorpID_0Corel-Layer"/>
  <g>
   <path class="fil0" d="M1345.52 35.23c723.59,0 1310.33,586.75 1310.33,1310.33 0,324.57 -118.93,622.93 -314.44,852.72l54.4 54.48 159.24 0 1008 1007.92 -302.4 302.41 -1007.93 -1008.01 0 -159.23 -54.47 -54.4c-229.79,195.5 -528.16,314.43 -852.73,314.43 -723.5,-0.07 -1310.25,-586.82 -1310.25,-1310.32 0,-723.58 586.75,-1310.33 1310.33,-1310.33l-0.08 0zm0 403.21c-503.92,0 -907.12,403.2 -907.12,907.12 0,504 403.2,907.2 907.12,907.2 504,0 907.2,-403.2 907.2,-907.2 0,-503.92 -403.2,-907.12 -907.2,-907.12z"/>
  </g>
 </g>
</svg>
